import { VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import {
  TableHeadContainer,
  TableHeadItem,
  TableHeadItemRecurse,
} from '../../../../../../../../components/TableHead';
import { useGlobalAssetContext } from '../../../../contexts';
import { useGlobalAssetController } from '../../../../hooks';

export interface AssetTableHeadProps {
  recurses: TableHeadItemRecurse[];
}

export const AssetTableHead: React.FC<AssetTableHeadProps> = ({ recurses }) => {
  const { orderBy, selectedTab } = useGlobalAssetContext();
  const { handleAutoOrderBy } = useGlobalAssetController();

  const handlePress = (value?: string) => {
    if (!value) {
      return;
    }
    handleAutoOrderBy(value);
  };

  if (selectedTab.hideTableHead) {
    return <></>;
  }

  return (
    <VStack space={Spacing['inline.nano']}>
      <TableHeadContainer px={Spacing['inline.xxxs']}>
        {recurses.map((item, index) => (
          <TableHeadItem
            key={`${item.title}-${index}`}
            {...item}
            value={item.orderValue}
            orderBy={orderBy}
            onPress={() => handlePress(item.orderValue as string)}
          />
        ))}
      </TableHeadContainer>
    </VStack>
  );
};
